import { OrganizationInfos } from '@damofire/data-stas';
import { Dto } from '@damofire/data-commons';
import { Issue } from '../issue/issue.dto';
import { Asset } from '../asset/asset.dto';

export interface Repair extends OrganizationInfos {
  _id?: string;
  number: string;
  upright: Partial<Asset>;
  issues: Partial<Issue>[];
  description: string;
  productInstalled: string;
}

export interface RepairMedia extends Dto {
  division?: { _id?: string };
  organization?: { _id?: string };
  repair?: { _id?: string };
  filename?: string;
  original?: string;
  thumb?: string;
  web?: string;
  size?: number;
  annotations?: any[];
}
